<app-entity-list
    [get-selected-data]="getSelectedData()"
    [rowData]="rowData()"
    [rowSelectedData]="rowSelectedData()"
    [rowClickBehaviour]="rowClickBehaviour()"
    [autoSizeStrategy]="autoSizeStrategy()"
    [columnDefs]="colDefs()"
    [features]="features()"
    [filter-options]="filterOptions()"
    [(filter-params)]="filterParams"
    [(refresh)]="refresh$"
    [navigationUrlTree]="navigationUrlTree()"
    [rowHeight]="RowHeight.TWO_LINE"
    (click-cell)="onCellClicked($event)"
    (click-row)="onRowClicked($event)"
    (select-row)="onRowSelected($event)"
    (select-changed)="onSelectionChanged($event)"
/>